/**
 * Created by wajidafaneh on 29/01/2017.
 */
(function (angular) {

    "use strict";

    angular
        .module('harriApp')
        .controller('CTViewShiftModalController', ["$scope", "$filter", "CTTimesheetService", "modalData", function ($scope, $filter, CTTimesheetService, modalData) {
            var brand = modalData.brand;
            var prepareBreaksForView = function () {
                var breaks = angular.copy($scope.shift.actual_clock.breaks) || [];
                for (var i = 0; i < breaks.length; i++) {
                    if (breaks[i].original_break_id) {
                        for (var j = 0; j < breaks.length; j++) {
                            if (breaks[i].original_break_id === breaks[j].id) {
                                breaks[j].paid = moment(breaks[j].end_time).diff(moment(breaks[j].start_time)) / (1000 * 60);
                                breaks[j].unpaid = moment(breaks[i].end_time).diff(moment(breaks[i].start_time)) / (1000 * 60);
                                breaks[j].end_time = breaks[i].end_time;
                                breaks.splice(i, 1);
                                break;
                            }
                        }
                    }
                }
                $scope.shift.actual_clock.breaks = breaks;
            };

            $scope.activeTab = 'DETAILS';
            $scope.shift = modalData.shift;
            prepareBreaksForView();
            $scope.date = modalData.shift.date;
            $scope.employeeId = modalData.employeeId;
            $scope.breaksRulesSet = CTTimesheetService.getBreaksRulesSet($scope.date);
            $scope.clockTimeStatusReasonTrackingMode = CTTimesheetService.getClockTimeStatusReasonTrackingMode($scope.date);
            $scope.shiftBasedScheduling = modalData.shiftBasedScheduling;
            $scope.hideUserEndTime = modalData.hideUserEndTime;

            $scope.troncColumnEnabled = (
                brand.tronc &&
                brand.tronc.mode === 'POINTS' &&
                brand.tronc.point_period_type === 'DAILY'
            );

            $scope.historyEntries = [];

            if ($scope.shift.actual_clock && $scope.shift.actual_clock.tronc) {

                var troncSources = {};
                var brandTronc = brand.tronc || {};
                var brandTroncSources = brandTronc.sources || [];
                var clockTronc = $scope.shift.actual_clock.tronc;
                var clockTroncSources = clockTronc.sources || [];

                for (var i in clockTroncSources) {
                    var source = clockTroncSources[i];
                    troncSources[source.code] = source;
                }

                $scope.tronc = {
                    sources: brandTroncSources.map(function (source) {
                        troncSources[source.code] = troncSources[source.code] || {};
                        source.amount = Utils.roundFloat((troncSources[source.code].amount || 0) / 100, 2);
                        return source;
                    })
                };
            }

            if ($scope.hideUserEndTime) {
                var businessDay = brand.business_day || [];
                var activeBusinessDay = {};

                for (var i = businessDay.length - 1; i >= 0; i--) {
                    var business = businessDay[i];

                    if (Date.parse(business.start_date) <= Date.parse($scope.date)) {
                        activeBusinessDay = business;
                        break;
                    }
                }

                if ($scope.shift.scheduled_shift) {
                    var closeTime = parseInt(activeBusinessDay.close_time * 1000);
                    var openTime = parseInt(activeBusinessDay.open_time * 1000);

                    if (closeTime <= openTime) {
                        closeTime += 24 * 60 * 60 * 1000;
                    }

                    var todayDate = moment($scope.date);
                    todayDate.hour(0);

                    var scheduleOutMoment = moment(todayDate.valueOf() + closeTime);

                    $scope.shift.scheduled_shift.clock_out = scheduleOutMoment.format("YYYY-MM-DD HH:mm");
                }
            }

            var parseHistory = function (data) {
                data = data || [];
                var isScheduledShift = !!$scope.shift.scheduled_shift;

                $scope.historyEntries = _.map(data, function (entry) {
                    if (entry.clock_edit_reason) {
                        var newAttribute = {
                            action: 'SET',
                            attribute: 'edit_card_reason',
                            to: entry.clock_edit_reason.reason
                        };

                        entry.attributes.push(newAttribute);
                    }


                    var attributes = [];

                    for (var i in entry.attributes) {
                        var attribute = entry.attributes[i];

                        if (attribute.attribute === 'actual_clock.category' && (attribute.from === 'NO_SHOW' || attribute.to === 'NO_SHOW')) {
                            var nextAttribute = entry.attributes[parseInt(i) + 1] || {};

                            if (nextAttribute.attribute === 'actual_clock.sick_leave') {
                                nextAttribute = entry.attributes[parseInt(i) + 2] || {};
                            }

                            if (nextAttribute.attribute === 'actual_clock.error_reason.id') {
                                if (!nextAttribute.to) {
                                    attribute.from_reason = nextAttribute.from;
                                } else {
                                    attribute.to_reason = nextAttribute.to;
                                }

                                nextAttribute.handled = true;
                            }
                        }

                        if (attribute.attribute === "actual_clock.breaks.end" && attribute.action === 'UPDATE') {

                            var splittedBreak = entry.attributes.find(function (attr) {
                                var originalBreak = (attr.meta && attr.meta.original_break) || {};
                                return attr.attribute === "actual_clock.breaks" && attr.action === 'ADD' &&
                                    originalBreak.id === (attribute.meta && attribute.meta.id);
                            });
                            if (splittedBreak) {
                                attribute.to = splittedBreak.meta['end_time'];
                            }
                        }
                        if (["actual_clock.right_to_rest",
                            "actual_clock.right_to_rest.status",
                            "actual_clock.right_to_rest.duration",
                            "actual_clock.right_to_rest.ignore_reason_id"
                        ].indexOf(attribute.attribute) > -1 &&
                            attribute.action === 'UPDATE' &&
                            attribute.meta.status !== "PENDING_APPROVAL") {
                            attribute.meta.clock_id = $scope.shift.actual_clock && $scope.shift.actual_clock.id;
                            attribute.meta.shift_id = $scope.shift.scheduled_shift && $scope.shift.scheduled_shift.id;
                            attribute.meta.employee_id = $scope.employeeId;
                        }

                        if (attribute.attribute === "actual_clock.breaks" && attribute.action === 'ADD') {
                            var originalBreak = attribute.meta.original_break || {};
                            if (originalBreak.id) {
                                continue;
                            }
                        }
                        if (!attribute.handled) {
                            attributes.push(attribute);
                        }

                        if (attribute.attribute === "actual_clock" && attribute.action === 'ADD') {
                            if (attribute.meta && attribute.meta.breaks && attribute.meta.breaks.length) {
                                var formattedBreaks = CTTimesheetService.formatTimeCardBreaks(attribute.meta.breaks);
                                for (var i in formattedBreaks) {
                                    var breakAttribute = {};
                                    if (formattedBreaks[i].start_time && formattedBreaks[i].end_time) {
                                        breakAttribute = {
                                            attribute: 'actual_clock.breaks',
                                            action: 'ADD',
                                            meta : formattedBreaks[i]
                                        }
                                        breakAttribute.meta['time_status'] = breakAttribute.meta['break_in_action'] && breakAttribute.meta['break_in_action']['time_status'];
                                    }
                                    else {
                                        breakAttribute = {
                                            attribute: 'actual_clock.breaks.status',
                                            action: 'UPDATE',
                                            meta : formattedBreaks[i]
                                        }
                                        breakAttribute.to = formattedBreaks[i].status;
                                    }
                                    attributes.push(breakAttribute);
                                }
                            }
                        }
                    }

                    entry.parsedAttributes = _.map(attributes, function (attribute) {
                        var msg = {};

                        var date = $filter("formatDateIgnoreTimeZone")($scope.date, "YYYY-MM-DD");
                        var splitShiftPenaltySettings = CTTimesheetService.getSplitShiftPenaltySettings(date);

                        CTTimesheetService.parseTimeCardHistoryEntry(attribute, $scope.breaksRulesSet, $scope.clockTimeStatusReasonTrackingMode, isScheduledShift, splitShiftPenaltySettings, entry.source)
                            .then(function (msgText) {
                                msg['text'] = msgText;
                                $scope.$digest();
                            });

                        return msg;
                    });

                    return entry;
                });
            };

            $scope.setActiveTab = function (tab) {
                $scope.activeTab = tab;
            };

            $scope.filterPaidBreaks = function (entry) {
                return ((['PAID', 'UNSCHEDULED_PAID'].indexOf(entry.type) > -1 && entry.original_source !== 'CONVERSION') ||
                        (['UNPAID', 'UNSCHEDULED_UNPAID'].indexOf(entry.type) > -1 && entry.original_source === 'CONVERSION')) &&
                    ['EMPLOYER_IGNORE', 'EMPLOYER_ADDED', 'EMPLOYER_DELETED'].indexOf(entry.status) === -1;
            };

            $scope.filterUnpaidBreaks = function (entry) {
                return ((['UNPAID', 'UNSCHEDULED_UNPAID'].indexOf(entry.type) > -1 && entry.original_source !== 'CONVERSION') ||
                        (['PAID', 'UNSCHEDULED_PAID'].indexOf(entry.type) > -1 && entry.original_source === 'CONVERSION')) &&
                    ['EMPLOYER_IGNORE', 'EMPLOYER_ADDED', 'EMPLOYER_DELETED'].indexOf(entry.status) === -1;
            };

            //Hide modal
            $scope.hideModal = function () {
                $scope.$hide();

                setTimeout(function () {
                    $scope.$digest();
                }, 1);
            };

            //Init
            (function () {

                //Load time card history
                PerformanceAggregatorAPI.getEmployeeTimeCardHistory(modalData.brand.id, modalData.shift.actual_clock.id, $filter("formatDateIgnoreTimeZone")($scope.date, "YYYY-MM-DD"))
                    .then(function (res) {
                        parseHistory(res.history);
                    }, function (err) {
                        console.error("couldn't load time card history", err);
                    });
            })();
        }]);

})(angular);
